import { render, staticRenderFns } from "./EmptyHistory.vue?vue&type=template&id=b57dcee8&scoped=true"
import script from "./EmptyHistory.vue?vue&type=script&lang=js"
export * from "./EmptyHistory.vue?vue&type=script&lang=js"
import style0 from "./EmptyHistory.vue?vue&type=style&index=0&id=b57dcee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57dcee8",
  null
  
)

export default component.exports